// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccuracyController from "./accuracy_controller"
application.register("accuracy", AccuracyController)

import AccuracyCompareController from "./accuracy_compare_controller"
application.register("accuracy-compare", AccuracyCompareController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import InitiativeSelectController from "./initiative_select_controller"
application.register("initiative-select", InitiativeSelectController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
